import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from "react-router-dom";
import { getRedirectURI } from "../utils/redirectURI";
import { useGitlabAccessToken } from '../hooks/GitlabAccessToken';
import { GITLAB_BASE_URL, GITLAB_CLIENT_ID } from '../config';


const NewVM = () => {
    const [accessToken] = useGitlabAccessToken()
    const navigate = useNavigate()
    const [seachParams] = useSearchParams()

    const namespace = seachParams.get('namespace');
    const project = seachParams.get('project');
    const ref = seachParams.get('ref');
    console.log({ namespace, project, ref });

    // const serverConnection = useServerConnection()

    // const startNewVm = () => {
    //     serverConnection.startNewVM()
    // }

    const redirectURI = getRedirectURI({
        project,
        namespace,
        ref,
    })

    useEffect(() => {
        if(accessToken) {
            navigate(`/confirm-vm-creation?project=${project}&namespace=${namespace}${ref ? `&ref=${ref}` : ''}`)
        } else {
            window.location.href = `${GITLAB_BASE_URL}/oauth/authorize?client_id=${GITLAB_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectURI)}&response_type=code&state=STATE&scope=api`
        }
    }, [])


    return (
        <div>
            {/* <button onClick={startNewVm} className="btn btn-primary">New VM</button> */}
        </div>
    )
}

export default NewVM